import { render, staticRenderFns } from "./ChangeAdminForLborder.vue?vue&type=template&id=789d6de6&scoped=true&"
import script from "./ChangeAdminForLborder.vue?vue&type=script&lang=js&"
export * from "./ChangeAdminForLborder.vue?vue&type=script&lang=js&"
import style0 from "./ChangeAdminForLborder.vue?vue&type=style&index=0&id=789d6de6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789d6de6",
  null
  
)

export default component.exports